import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { readConsent, saveConsent } from "../lib/analytics";

export const openCookieSettings = () => window.dispatchEvent(new Event("ss-cookie-settings"));

export const CookieBanner = () => {
  const top = useLocation().pathname.startsWith("/stb/");
  const [open, setOpen] = useState(() => !readConsent());
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("ss-cookie-settings", show);
    return () => window.removeEventListener("ss-cookie-settings", show);
  }, []);
  if (!open) return null;
  const choose = (v) => { saveConsent(v); setOpen(false); };
  return (
    <div role="dialog" aria-label="Cookie choices" className={`fixed inset-x-2 z-[60] border-2 border-slate-900 bg-white ${top ? "p-2.5" : "p-4"} shadow-[6px_6px_0_0_#0f172a] sm:inset-x-auto sm:left-5 sm:max-w-md ${top ? "top-2 sm:top-5" : "bottom-2 sm:bottom-5"}`} data-testid="cookie-banner">
      {!top && <div className="flex items-center gap-2 font-display text-base font-extrabold uppercase"><Cookie className="h-5 w-5" /> Cookies</div>}
      <p className={top ? "text-xs text-slate-600" : "mt-2 text-sm text-slate-600"}>
        {top ? "Can we use Google ad cookies to see which ads work? Optional." : "We'd like to use Google advertising cookies to see which of our ads work. They're only set if you accept. The site works the same either way."}{" "}
        <Link to="/privacy#cookies" className="font-bold text-slate-900 underline" data-testid="cookie-banner-policy-link">Cookie policy</Link>
      </p>
      <div className={`grid grid-cols-2 gap-2 ${top ? "mt-2" : "mt-3"}`}>
        <button type="button" onClick={() => choose("denied")} className={`border-2 border-slate-900 bg-white px-4 ${top ? "py-1.5" : "py-2.5"} text-sm font-bold uppercase transition-colors hover:bg-slate-100`} data-testid="cookie-reject-button">Reject</button>
        <button type="button" onClick={() => choose("granted")} className={`border-2 border-slate-900 bg-slate-900 px-4 ${top ? "py-1.5" : "py-2.5"} text-sm font-bold uppercase text-lime-300 transition-colors hover:bg-slate-800`} data-testid="cookie-accept-button">Accept</button>
      </div>
    </div>
  );
};
